import { useMeFavouritePartner, type WalletCustody } from '@capsicum/common';
import { useCallback } from 'react';

import { usePartners } from '../../partners/hooks/usePartners';
import { useMyNftsQuery } from '../data-access/queries/useMyNftsQuery';
import { type MyNft, type MyNfts } from '../models/myNfts';
import { mapPartnerToNftPartner } from '../util/mapPartnerToNftPartner';

/**
 * @returns favorite partner nfts and other nfts owned by user
 */
export const useMyNfts = (walletCustody: WalletCustody) => {
	const { favoritePartner } = useMeFavouritePartner();
	const { getPartnerBy } = usePartners();

	return useMyNftsQuery(
		useCallback(
			(data): MyNfts | undefined =>
				data?.reduce(
					(myNfts, nft) => {
						const partnerId = nft?.summary?.references?.partnerId;
						const partner = getPartnerBy(p => p.id === partnerId);

						const myNft: MyNft = {
							...nft,
							partner: mapPartnerToNftPartner(partner)
						};

						if (partnerId === favoritePartner?.id) {
							myNfts.favoriteNfts.push(myNft);
						} else {
							myNfts.nfts.push(myNft);
						}

						return myNfts;
					},
					{
						favoriteNfts: [],
						nfts: []
					} as MyNfts
				),
			[favoritePartner?.id, getPartnerBy]
		),
		{
			direction: 'desc',
			orderBy: 'createdAt',
			walletCustody
		}
	);
};
